import Grid from '@mui/material/Grid';
import React, { useState, useEffect } from 'react';
import { TRIGGER_TYPES } from '../../../constants/_pickerValues';
import TextField from '@mui/material/TextField';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { GridSelectionModel } from '@mui/x-data-grid';
import Radio from '@mui/material/Radio';
import { useDispatch } from "react-redux";
import * as taskDispatch from '../../../store/eventBasedTrigger/actions';
import { ITaskListParams, ILoaderListParams } from '../../../store/eventBasedTrigger/types'
import { timeZoneValues } from '../../../constants/_pickerValues'
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import cronstrue from 'cronstrue'
import format from 'date-fns/format'
import ExtractorExplorer from "../../../components/organisms/extractorExplorer/ExtractorExplorer";
import LoaderExplorer from '../../organisms/loaderExplorer/LoaderExplorer';
import AppConfig from "../../../config/AppConfig";

export type TriggerProps = {
  onChange: any
  value: any
  type: string

};


const TriggerRow = (props: TriggerProps) => {
  const [defaultTimezone, setDefaultTimezone] = useState(`${format(new Date(), 'xxx')} UTC`);
  const [triggerType, setTriggerType] = useState('')
  const [extractorName, setExtractorName] = useState('')
  const [loaderName, setLoaderName] = useState('')
  const [open, setOpen] = React.useState(false);
  const [openLoader, setOpenLoader] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleOpenLoader = () => setOpenLoader(true);
  const dispatch = useDispatch()
  const [selectedExtractor, setSelectedExtractor] = useState<GridSelectionModel>();
  const [selectedLoader, setSelectedLoader] = useState<GridSelectionModel>();
  const [timeLevel, setTimeLevel] = useState('');
  const [cronValues, setCronValues] = useState({
    minute: '*',
    hour: '*',
    day: '*',
    month: '*',
    dayOfWeek: '*'
  });
  const [cronString, setCronString] = useState('* * * * *');
  const [uuidString, setUuidString] = useState(props.value.uuid)
  const [customCron, setCustomCron] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);
  const [repeatTime, setRepeatTime] = useState(cronstrue.toString(cronString));

  const extractorParams: ITaskListParams = {
    taskType: "Extract_Task"
  };

  const loaderParams: ILoaderListParams = {
    taskType: "Loader_Task"
  };

  const tableSelectorstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1300,
    background: "white",
    height: 700,
    p: 4,
    overflowY: "auto",
  };

  useEffect(() => {
    if ((props.value.cronExpression && props.value.taskType === "Extract_Task") || (props.value.cronExpression && props.value.taskType === "Loader_Task")) {
      setTriggerType(TRIGGER_TYPES.timeBased);
      setDefaultTimezone(`${props.value.timezone} UTC`);
      setRepeatTime(cronstrue.toString(props.value.cronExpression));
    }

    if (props.value.eventType === "EXTRACT_TASK.SUCCESS") {
      setTriggerType(TRIGGER_TYPES.dataExtractor)
      setExtractorName(props.value.description)
    }
    else if (props.value.eventType === "LOAD_TASK.SUCCESS") {
      setTriggerType(TRIGGER_TYPES.dataLoader);
      setLoaderName(props.value.description);
    }

    if (props.value.eventType === "WEB_HOOK.INBOUND") {
      setTriggerType(TRIGGER_TYPES.inboundWebhook)
    }

  }, []);


  const handleChange = (event: {}) => {
    const e = event as React.ChangeEvent<HTMLInputElement>;
    props.onChange({
      ...props.value,
      [e.target.name]: e.target.value,
    })
    setDefaultTimezone((`${e.target.value}`));
  }


  const handledropDownChange = (event: SelectChangeEvent) => {
    setTriggerType(event.target.value as string);
    if (event.target.value.toString() === TRIGGER_TYPES.inboundWebhook) {
      setUUID();
    } else if (event.target.value.toString() === TRIGGER_TYPES.timeBased) {
      setCronString('0 0 * * *')
    }
    
  };

  const handleChangeTimeGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTimeLevel((event.target as HTMLInputElement).value)
    if (event.target.value === 'daily') {
      setCronValues({ 'minute': '0', 'hour': '0', 'day': '*', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    } else if (event.target.value === 'weekly') {
      setCronValues({ 'minute': '0', 'hour': '0', 'day': '*', 'month': '*', 'dayOfWeek': 'Mon' })
      setErrorMessage(false)
    } else if (event.target.value === 'monthly') {
      setCronValues({ 'minute': '0', 'hour': '0', 'day': '1', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    } else if (event.target.value === '15min') {
      setCronValues({ 'minute': '*/15', 'hour': '*', 'day': '*', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    } else if (event.target.value === '30min') {
      setCronValues({ 'minute': '*/30', 'hour': '*', 'day': '*', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    } else if (event.target.value === '60min') {
      setCronValues({ 'minute': '0', 'hour': '*', 'day': '*', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    } else if (event.target.value === 'other') {
      setCronValues({ 'minute': '0', 'hour': '0', 'day': '1', 'month': '*', 'dayOfWeek': '*' })
      setErrorMessage(false)
    }
  }

  const handleChangeMinute = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCronValues({ ...cronValues, 'minute': event.target.value.toString() })
  }

  const handleChangeHour = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCronValues({ ...cronValues, 'hour': event.target.value.toString() })
  }

  const handleChangeDay = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCronValues({ ...cronValues, 'day': event.target.value.toString() })
    setErrorMessage(false)
  }

  const handleChangeDayOfWeek = (event: SelectChangeEvent) => {
    setCronValues({ ...cronValues, 'dayOfWeek': event.target.value })
    setErrorMessage(false)
  }

  const handleChangeAdvancedCron = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCustomCron(event.target.value)
    let space = /\s/

    if (space.test(event.target.value)) {
      const cronExpr = parseCron(event.target.value)
      setCronValues(cronExpr)
      setErrorMessage(false)
    }
    else {
      setErrorMessage(true)
    }

  }

  const handleClickApplyButton = () => {
    setCronString(generateCron(cronValues))
    setTimeLevel('')
    props.onChange({
      ...props.value,
      ['cronExpression']: generateCron(cronValues),
    })
    setOpen(false);
    setRepeatTime(cronstrue.toString(generateCron(cronValues)));
  }

  const handleClose = () => {
    setOpen(false);
    setOpenLoader(false);
  }


  const setUUID = () => {
    setUuidString(`${AppConfig().BaseUrl}api/v1/webhooks/{webhook}?type=${props.type}`)
  }

  useEffect(() => {
    props.onChange({
      ...props.value,
      ['webhook']: uuidString,
    })
  }, [uuidString])

  const parseCron = (cronString: string) => {
    const [minute, hour, day, month, dayOfWeek] = cronString.split(' ')
    return { minute, hour, day, month, dayOfWeek }

  }

  const generateCron = (cronObj: object) => {
    return [...Object.values(cronObj)].join(' ')
  }


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1200,
    bgcolor: 'background.paper',
    height: 700,
    p: 4,
  };

  const buttonStyle = {
    background: 'white',
    width: 1200,
    ml: -4,
    p: 2,
  };

  const pickerModalStyle = {
    position: 'absolute',
    right: '0%',
    height: '100%',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const applyButtonStyle = {
    // top: '70%',
    // position: 'absolute',
    top: '1em'
  }

  return (
    <>
      <Grid item xs={3}>
        <FormControl fullWidth>
          <InputLabel id="trigger-label">Trigger</InputLabel>
          <Select
            labelId="trigger-label"
            label="Trigger"
            value={triggerType}
            onChange={handledropDownChange}
          >
            <MenuItem value={TRIGGER_TYPES.timeBased}>{TRIGGER_TYPES.timeBased}</MenuItem>
            <MenuItem value={TRIGGER_TYPES.dataExtractor}>{TRIGGER_TYPES.dataExtractor}</MenuItem>
            <MenuItem value={TRIGGER_TYPES.dataLoader}>{TRIGGER_TYPES.dataLoader}</MenuItem>
            <MenuItem value={TRIGGER_TYPES.inboundWebhook}>{TRIGGER_TYPES.inboundWebhook}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {triggerType === TRIGGER_TYPES.timeBased ? <>
        <Grid item xs={4}>
          <div>
            <TextField
              id="cron"
              label="When to Repeat"
              value={repeatTime}
              onClick={() => setOpen(true)}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
            />
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={pickerModalStyle}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Select when to repeat
                </Typography>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    onChange={handleChangeTimeGroup}
                  >
                    <FormControlLabel value="15min" control={<Radio />} label="Every 15 minutes" />
                    <FormControlLabel value="30min" control={<Radio />} label="Every 30 minutes" />
                    <FormControlLabel value="60min" control={<Radio />} label="Hourly" />
                    <FormControlLabel value="daily" control={<Radio />} label="Daily" />
                    {
                      timeLevel === "daily" ?
                        <Box
                          component="form"
                          sx={{ '& > :not(style)': { m: 1, width: '15ch' }, }}
                          noValidate
                          autoComplete="off">
                          <TextField
                            id="outlined-name"
                            label="Hour"
                            value={parseInt(cronValues.hour)}
                            InputProps={{ inputProps: { min: 0, max: 23 } }}
                            onChange={handleChangeHour}
                            sx={{ 'width': '150px', 'paddingBottom': '20px' }}
                            type="number"
                          />
                          <TextField
                            name="minute"
                            label="Minute"
                            value={parseInt(cronValues.minute)}
                            InputProps={{ inputProps: { min: 0, max: 59 } }}
                            onChange={handleChangeMinute}
                            sx={{ 'width': '150px', 'paddingBottom': '20px' }}
                            variant="outlined"
                            type="number"
                          />
                        </Box>
                        : null
                    }

                    <FormControlLabel value="weekly" control={<Radio />} label="Weekly" />
                    {
                      timeLevel === "weekly" ?
                        <Box
                          component="form"
                          sx={{ '& > :not(style)': { m: 1, width: '10ch' }, }}
                          noValidate
                          autoComplete="off">
                          <FormControl fullWidth>
                            <InputLabel htmlFor='select-weekday'>Weekday</InputLabel>
                            <Select
                              labelId="select-weekday-label"
                              id="select-weekday"
                              value={cronValues.dayOfWeek}
                              label="Weekday"
                              sx={{ 'width': "100px" }}
                              onChange={handleChangeDayOfWeek}
                            >
                              <MenuItem value={"Sun"}>Sunday</MenuItem>
                              <MenuItem value={"Mon"}>Monday</MenuItem>
                              <MenuItem value={"Tue"}>Tuesday</MenuItem>
                              <MenuItem value={"Wed"}>Wednesday</MenuItem>
                              <MenuItem value={"Thu"}>Thursday</MenuItem>
                              <MenuItem value={"Fri"}>Friday</MenuItem>
                              <MenuItem value={"Sat"}>Saturday</MenuItem>
                            </Select>
                          </FormControl>
                          <TextField
                            name="hour"
                            label="Hour"
                            value={parseInt(cronValues.hour)}
                            onChange={handleChangeHour}
                            InputProps={{ inputProps: { min: 0, max: 23 } }}
                            variant="outlined"
                            sx={{ 'width': '50px', 'paddingBottom': '20px' }}
                            type="number" />
                          <TextField
                            name="minute"
                            label="Minute"
                            value={parseInt(cronValues.minute)}
                            onChange={handleChangeMinute}
                            InputProps={{ inputProps: { min: 0, max: 59 } }}
                            sx={{ 'width': '50px', 'paddingBottom': '20px' }}
                            variant="outlined"
                            type="number" />
                        </Box>
                        : null
                    }

                    <FormControlLabel value="monthly" control={<Radio />} label="Monthly" />
                    {
                      timeLevel === 'monthly' ?
                        <Box
                          component="form"
                          sx={{ '& > :not(style)': { m: 1, width: '10ch' }, }}
                          noValidate
                          autoComplete="off">
                          <TextField
                            name="day"
                            label="Day"
                            value={parseInt(cronValues.day)}
                            onChange={handleChangeDay}
                            InputProps={{ inputProps: { min: 1, max: 31 } }}
                            variant="outlined"
                            sx={{ 'width': '50px', 'paddingBottom': '20px' }}
                            type="number" />
                          <TextField
                            name="hour"
                            label="Hour"
                            value={parseInt(cronValues.hour)}
                            onChange={handleChangeHour}
                            InputProps={{ inputProps: { min: 0, max: 23 } }}
                            variant="outlined"
                            sx={{ 'width': '50px', 'paddingBottom': '20px' }}
                            type="number" />
                          <TextField
                            name="minute"
                            label="Minute"
                            value={parseInt(cronValues.minute)}
                            onChange={handleChangeMinute}
                            InputProps={{ inputProps: { min: 0, max: 59 } }}
                            sx={{ 'width': '50px', 'paddingBottom': '20px' }}
                            variant="outlined"
                            type="number" />
                        </Box>
                        : null
                    }

                    <FormControlLabel value="other" control={<Radio />} label="Cron (advanced)" />
                    {
                      timeLevel === 'other' ?
                        <TextField
                          name="cron"
                          label="Cron (e.g. 0 0 1 * * )"
                          value={customCron}
                          onChange={handleChangeAdvancedCron}
                          // defaultValue={'0 0 * * *'}
                          sx={{ 'width': '300px' }}
                          variant="outlined" />
                        : null
                    }

                  </RadioGroup>
                  {errorMessage ? <span style={{color: 'red', fontSize: '0.9em', marginTop:'1em'}}>Please check the cron expression format</span> : ''}
                  <Button id="d1219798-5358-4340-8bff-28f49c3bd9b5" sx={applyButtonStyle} color="primary" variant="contained" onClick={handleClickApplyButton}>Apply</Button>
                </FormControl>

              </Box>
            </Modal>
          </div>
        </Grid>
        <Grid item xs={3}>
          <FormControl fullWidth>
            <InputLabel id="time-label">Timezone</InputLabel>
            <Select
              labelId="time-label"
              label="Time Based"
              name="timezone"
              value={defaultTimezone}
              onChange={handleChange}
            >
              {timeZoneValues.map((item, index) => {
                return (
                  <MenuItem value={item} key={index}> {item} </MenuItem>
                )
              })}
              <MenuItem value={TRIGGER_TYPES.timeBased}>{TRIGGER_TYPES.timeBased}</MenuItem>

            </Select>
          </FormControl>
        </Grid>
      </> : ''}
      {triggerType === TRIGGER_TYPES.inboundWebhook ? <> <Grid item xs={5}>
        <FormControl fullWidth>
          <TextField
            name="webhook"
            value={uuidString ?? ""}
            InputProps={{
              readOnly: true,
            }}
            type="text" />
        </FormControl>
      </Grid>
      </> : ''}

      {triggerType === TRIGGER_TYPES.dataExtractor ? <Grid item xs={3}>
        <Button id="a514ea77-3d02-49f9-8b93-cb4c14064462"
          color="primary"
          variant="contained"
          onClick={handleOpen}
        >
          Set Extractor
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ overflowY: "auto" }}
                  >
                    <Box sx={tableSelectorstyle}>
                      <ExtractorExplorer
                        selectable={"single"}
                        selectorField={"taskId"}
                        selectedValue={selectedExtractor}
                        onSelect={(item: any) => {
                          setSelectedExtractor(item.taskId)
                          setExtractorName(item.description ? item.description : "No description")
                          props.onChange({
                            ...props.value,
                            'extractor': [{ newExtractorId: item.taskId, description: item.description }],
                          })}}
                        displayIcons={false}
                        displayActionButtons={false}
                      />
                      <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2, mb: 2 }}
                      />
                      <Box
                        sx={buttonStyle}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button id="7c13358a-fc40-4e73-b89f-755eaa847008"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                        >
                          Close
                        </Button>
                        <Button id="d372d4bd-9708-41e8-9b2f-fa3d38bd78e6"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                          sx={{ ml: 1 }}
                        >
                          Select
                        </Button>
                      </Box>
                    </Box>
                  </Modal>
              <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                <Button id="3cada859-6539-4e83-a447-d5c13976bd12" color="primary" variant="contained" onClick={handleClose}>Select Extractor</Button>
              </Box>
            </Typography>
          </Box>
        </Modal>

      </Grid> : ''}
      {triggerType === TRIGGER_TYPES.dataExtractor ? <Grid item xs={4}>
        <p>{extractorName ? extractorName : ''}</p>
      </Grid> : ''}
      {triggerType === TRIGGER_TYPES.dataLoader ? <Grid item xs={3}>
        <Button id="af43cb45-c23a-43af-b7b6-24372302d4b9"
          color="primary"
          variant="contained"
          onClick={handleOpenLoader}
        >
          Set Loader
        </Button>
        <Modal
          open={openLoader}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
                <Modal
                    open={openLoader}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ overflowY: "auto" }}
                  >
                    <Box sx={tableSelectorstyle}>
                      <LoaderExplorer
                        selectable={"single"}
                        selectorField={"taskId"}
                        selectedValue={selectedLoader}
                        onSelect={(item: any) => {
                          setSelectedLoader(item.taskId)
                          setLoaderName(item.description ? item.description : "No description")
                          props.onChange({
                            ...props.value,
                            'loader': [{ newLoaderId: item.taskId, description: item.description }],
                          })}}
                          displayActionButtons={false}
                      />
                      <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2, mb: 2 }}
                      />
                      <Box
                        sx={buttonStyle}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Button id="fc7fbfbd-a369-460d-b03e-dfab265bde2e"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                        >
                          Close
                        </Button>
                        <Button id="4cb35399-5df3-4bef-b3e7-e4f6ddc6d482"
                          color="primary"
                          variant="contained"
                          onClick={handleClose}
                          sx={{ ml: 1 }}
                        >
                          Select
                        </Button>
                      </Box>
                    </Box>
                  </Modal>
              <Box sx={buttonStyle} display="flex" justifyContent="flex-end">
                <Button id="a2bb7d4b-9468-457d-8f62-52dfb8ca2bda" color="primary" variant="contained" onClick={handleClose}>Select Extractor</Button>
              </Box>
            </Typography>
          </Box>
        </Modal>
      </Grid> : ''}
      {triggerType === TRIGGER_TYPES.dataLoader ? <Grid item xs={4}>
        <p>{loaderName ? loaderName : ''}</p>
      </Grid> : ''}
    </>

  )


};

export default TriggerRow;